export default __webpack_public_path__ + "static/3-55c2c2593177dcfaa7bbdd471a5264b5.png";